import RestAPIClient from "services/RestAPIClient";

class UploadServices extends RestAPIClient {
  constructor() {
    super("");
  }

  uploadFile = async (url: string, req: any, onProgress: any): Promise<any> => {
    const response = await this.upload(url, req, onProgress);
    return response;
  };
}

export default new UploadServices();
